
import {
  Vue,
  Component,
  Prop,
  Watch,
} from 'vue-property-decorator';
import Quill from 'quill';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import api from '@/api/course';
import { quillEditor } from 'vue-quill-editor';
import thirdStep from '@/views/Home/layout/course/info/components/secondStep.vue';
const AlignStyle = Quill.import('attributors/style/align')
const BackgroundStyle = Quill.import('attributors/style/background')
const ColorStyle = Quill.import('attributors/style/color')
const DirectionStyle = Quill.import('attributors/style/direction')
const FontStyle = Quill.import('attributors/style/font')
const SizeStyle = Quill.import('attributors/style/size')
FontStyle.whitelist = ['Microsoft YaHei', 'serif', 'monospace']
SizeStyle.whitelist = ['10px', '12px', '14px', '16px', '18px', '20px', '22px', '24px', '26px', '28px', '30px']
Quill.register(AlignStyle, true)
Quill.register(BackgroundStyle, true)
Quill.register(ColorStyle, true)
Quill.register(DirectionStyle, true)
Quill.register(FontStyle, true)
Quill.register(SizeStyle, true)

@Component({
  components: {
    quillEditor,
  },
})

export default class tEditor extends Vue {
  @Prop({
    required: true,
    default: '',
  }) content!: string;

  @Prop({
    required: true,
    default: [
      ['bold', 'italic', 'underline', 'strike'],
      ['blockquote', 'code-block'],
      [{ header: 1 }, { header: 2 }],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ script: 'sub' }, { script: 'super' }],
      [{ indent: '-1' }, { indent: '+1' }],
      [{ direction: 'rtl' }],
      [{ size: ['10px', false, '12px', '14px', '16px', '18px', '20px', '22px', '24px', '26px', '28px', '30px'] }],
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [{ color: [] }, { background: [] }],
      [{ font: ['serif', 'monospace', 'Microsoft YaHei'] }],
      [{ align: [] }],
      ['clean'],
      ['link', 'image', 'video'],
    ],
  }) toolbarOptions!: any;

  @Prop({
    required: true,
    default: '200px',
  }) height?: string;

  @Prop({
    default: '',
  }) placeholder!: string;

  get style() {
    const css:any = {};
    css.height = `${parseInt(this.height ? this.height : '', 10) - 82}px` || '100px';
    return css;
  }

  private oldContent: string = '';

  private value: string = '';

  public $refs!:{
    editor: any;
  }

  private options: any = {
    placeholder: '请输入咨询详情',
    scrollingContainer: '.ql-editor',
    modules: {
      toolbar: {
        container: this.toolbarOptions,
        handlers: {
          image: () => {
            const uploadFile = document.createElement('input');
            uploadFile.setAttribute('type', 'file');
            uploadFile.click();
            uploadFile.onchange = () => {
              const file = uploadFile.files ? uploadFile.files[0] : '';
              if (/^image\//.test(file ? file.type : '')) {
                const data = new FormData();
                data.append('file', file);
                api.picStore(data).then((res: any) => {
                  const url = res.path;
                  if (!this.$refs.editor.quill.getSelection().index) {
                    this.$refs.editor.quill.getSelection().index = 0;
                  }
                  this.$refs.editor.quill.insertEmbed(this.$refs.editor.quill.getSelection().index,
                    'image', url);
                  this.$refs.editor.quill.setSelection(this.$refs.editor.quill.getSelection().index
                  + 1);
                });
              }
            };
          },
          imageResize: {
            displaySize: true,
          },
        },
      },
    },
  }

  created() {
    if (this.placeholder !== '') {
      this.options.placeholder = this.placeholder;
    }
  }

  /**
   * @author liangyongmou
   * @desc 重置富文本编辑器
   */
  refresh() {
    this.$refs.editor.quill.container.firstChild.innerHTML = this.oldContent;
  }

  contentChange(v: any) {
    this.$emit('change', v.html);
  }

  @Watch('content', { immediate: true })
  getContent(v: string) {
    this.value = v;
  }

  @Watch('value', { immediate: true })
  getValue(newVal: string, oldVal: string) {
    // console.log(newVal)
    // console.log(this.$refs.editor.quill.selection.savedRange.index)
    if (!oldVal && newVal.length > 8) {
      this.$refs.editor.quill.enable(false);
      this.$nextTick(() => {
        this.$refs.editor.quill.enable(true);
      });
    }
  }
}
